import { SeverityLevel } from '@microsoft/applicationinsights-web';
import axios from 'axios';
import { apiEndPointFromNode } from "client.config";
import { Trans } from "react-i18next";
import { getAppInsights } from "../../../App/TelemetryService";
import {
    checkAndGetLocalStorageValue,
    generateJsonWebToken,
    nodeEncryptedToken,
} from "../../../features/utils";
import { commonConstant } from "../../../server/triage/constants";

export async function getNodeCallBack(state, setState, actions, command) {
  try {
    let response = await axios
      .get(apiEndPointFromNode + command, {
        headers: {
          "authorization": checkAndGetLocalStorageValue("accessToken"),
          "iscomingfromss": true,
          "customauth": generateJsonWebToken(), //5197 for non-user validation
        },
    });
    return response.data
  }
  catch (error) {
    catchBlockCall(state, setState, actions, error)
  }
}

export async function postNodeCallBack(state, setState, actions, command, body) {
 var encryptedBody = {
  encryptedValue : nodeEncryptedToken(body)
}
  try {    
    let response = await axios.post(apiEndPointFromNode + command, encryptedBody, {
        headers: {
          "authorization": checkAndGetLocalStorageValue("accessToken"),
          "iscomingfromss": true,
          "customauth": generateJsonWebToken() //5197 for non-user validation,         
        },
      });
    return response.data
  }
  catch (error) {
    catchBlockCall(state, setState, actions, error)
  }
}

function catchBlockCall(state, setState, actions, error) {
  getAppInsights().trackException({
    error: new Error(error),
    severityLevel: SeverityLevel.Error
  })

  var pageFlow = commonConstant.APIError;
  var errorMessage = <Trans i18nKey="SomethingWentWrong"></Trans>;
  if (state.azure.accessToken == null && !state.IsValidUser) {
    pageFlow = commonConstant.PreLogin;
    errorMessage = <Trans i18nKey="SomethingWentWrongPreLogin"></Trans>;
  }

  actions.setErrorModal({
    title: <Trans i18nKey="findcareoption.Careoptions.Please_confirm"></Trans>,
    message: errorMessage,
    comingFrom: pageFlow,
    setState
  })
  return;
}